import { combineReducers } from 'redux';
import login from './login';
import modal from './modal';
import contact from './contact'
import notification from './notification'
import usercardBreakdown from './usercardBreakdown'
import usercardCount from './usercardCount'
import usercardBooking from './usercardBooking'
import itemRegister from './dbReport/itemRegister'
import monetizeBooking from './monetize/booking'
import memberUser from './member/eparkLoginUser'
import shopSearchHitrate from './dbReport/shopSearchHitrate'
import uservoiceContact from './uservoice/contact'
import uservoiceRequest from './uservoice/request'

const rootReducer = combineReducers({
  auth: login,
  modal: modal,
  contact: contact,
  notification: notification,
  usercardBreakdown: usercardBreakdown,
  usercardCount: usercardCount,
  usercardBooking: usercardBooking,
  itemRegister: itemRegister,
  shopSearchHitrate: shopSearchHitrate,
  monetizeBooking: monetizeBooking,
  memberUser: memberUser,
  uservoiceContact: uservoiceContact,
  uservoiceRequest: uservoiceRequest
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js